module.exports = __webpack_public_path__ + "img/hero-img-blog.33354f54.svg";